import React, { useState, useEffect } from 'react';
import { Grid } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import TeamQuotaPanel from './TeamQuotaPanel';
import { fetchTeamQuotaData, getTeamAndFiscalQuarters } from './redux/management.thunk';
import { clearManagementSlice } from './redux/management.slice';
import AddHeaderDescriptionWithHelperText from '../../components/HelperTextDescription';
import UpdateFiscalQuarterFilter from './components/UpdateFiscalQuarterFilter';
import QuotaRemoval from './QuotaManagement/QuotaRemoval';
import QuotaManagementToggle from './components/QuotaManagementToggle';
import AddTeamQuotaView from './QuotaManagement/AddTeamQuotaView';

const TeamManagementContainer = () => {
  const [view, setView] = useState('add');
  const [touched, setTouched] = useState(false);
  const dispatch = useDispatch();

  const headerText = "Team Quota Management";
  const descriptionText = "Add / Delete / Update Quota for Teams";

  useEffect(() => {
    dispatch(getTeamAndFiscalQuarters({ type: 'team' }));

    return () => {
      dispatch(clearManagementSlice());
    };
  }, [dispatch]);

  const handleChangeView = (event, newView) => {
    if (newView !== null) {
      if (touched) {
        if (window.confirm("You have unsaved changes. Do you want to discard and switch view?")) {
          setView(newView);
          setTouched(false);
        }
      } else {
        setView(newView);
      }
    }
  };

  const toggleButtonStyle = (buttonView) => ({
    background: view === buttonView ? "#4472C4" : "",
    color: view === buttonView ? "white" : "",
    fontSize: "1rem",
    fontWeight: 600,
    height: "3.5rem",
    width: "14rem",

  });

  return (
    <Grid container spacing={2}>
      <Grid container item style={{ margin: "1rem 0rem" }}>
        <AddHeaderDescriptionWithHelperText
          header={headerText}
          description={descriptionText}
        />
      </Grid>
      <Grid item xs={12}>
        <QuotaManagementToggle
          section="Team"
          view={view}
          handleChangeView={handleChangeView}
          toggleButtonStyle={toggleButtonStyle}
        />
      </Grid>
      <Grid item xs={12}>
        {view === 'add' && <AddTeamQuotaView />}
        {view === 'remove' && <QuotaRemoval mode="team" />}
        {view === 'update' && (
          <>
            <Grid item xs={12}>
              <UpdateFiscalQuarterFilter touched={touched} setTouched={setTouched} fetchData={fetchTeamQuotaData} type="team" />
            </Grid>
            <TeamQuotaPanel setTouched={setTouched} />
          </>
        )}
      </Grid>
    </Grid>
  );
};

export default TeamManagementContainer;
